'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 22px;\n    height: 22px;\n    border-radius: 11.3px;\n    background-color: #f7f8fc;\n    display: inline-block;\n    position : absolute;\n    top: 0;\n    cursor: pointer;\n    bottom: 0;\n    margin: auto;\n    color: #b8c2cb;\n    font-weight: bold;\n    ', ' : 10px;\n    &:after {\n        content :  ', ';\n        text-align: center;\n        font-size: 12px;\n        color: #b8c2cb;\n        margin: auto;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n    }\n'], ['\n    width: 22px;\n    height: 22px;\n    border-radius: 11.3px;\n    background-color: #f7f8fc;\n    display: inline-block;\n    position : absolute;\n    top: 0;\n    cursor: pointer;\n    bottom: 0;\n    margin: auto;\n    color: #b8c2cb;\n    font-weight: bold;\n    ', ' : 10px;\n    &:after {\n        content :  ', ';\n        text-align: center;\n        font-size: 12px;\n        color: #b8c2cb;\n        margin: auto;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n    }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DoubleArrow = _styledComponents2.default.span(_templateObject, function (props) {
    return props.left ? 'left' : 'right';
}, function (props) {
    return props.left ? '"<<"' : '">>"';
});

exports.default = DoubleArrow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/DoubleArrow.js
// module id = 483
// module chunks = 0